/**
 * CMC_VIEW_OPTIONS — options for the /cmc command (CommandBar autocomplete).
 * label — short display name shown in the dropdown
 * value — passed to the /cmc handler to pick which cmc card to open
 *
 * Only 'usage' for now — /cmcfear stays a separate command until it's folded
 * into this one as well (later, not now).
 */
export const CMC_VIEW_OPTIONS = [
    { label: 'Usage', value: 'usage' },
    { label: 'Fear', value: 'fear' },
    { label: 'Assets', value: 'assets' },
];
